const _ = require('lodash');
const aboutModelTemplate = require('./about-model.hbs');
import { SettingsService } from '../../../services/settings-service';

export default class AboutModelController {
	private updateView: any;
	private utilityService: any;
	private isVisible: boolean;
	private link;

	get settingsService() {
		return this.utilityService.settingsService;
	}

	constructor(updateView, utilityService) {
		this.updateView = updateView;
		this.utilityService = utilityService;
	}

	public initHandling() {
		const self = this;
		if (self.isVisible) {
			const closeBtn = document.getElementById('uc-close-about');
			if (closeBtn) {
				closeBtn.onclick = () => {
					self.visible = false;
					self.updateView();
				};
			}
		}
	}

	private getHtml() {
		let viewHTML: any;
		const layoutParams: any = this.getPreparedLayoutParams();
		switch (layoutParams.view) {
		case 'about-model':
			viewHTML = aboutModelTemplate;
			break;
		default:
			break;
		}
		return viewHTML({
			link: this.link
		});
	}

	private getPreparedLayoutParams() {
		const layouts = SettingsService.layouts;
		const goalLayout = _.find(layouts, {
			name: this.settingsService.settings.layout
		});

		return {
			view: goalLayout.aboutModalView
			//todo
		};
	}

	public get visible() {
		return this.isVisible;
	}

	public set visible(_visible) {
		this.isVisible = _visible;
	}

	public set url(_link) {
		this.link = _link;
	}

	public get htmlString(): string {
		if (this.visible) {
			return this.getHtml();
		} 
		return '';
	}
}
